import { Box, Skeleton, Typography } from '@mui/material';
import type { FC } from 'react';
import { styled } from '@mui/material/styles';
import { useFamilyMemberProfile } from '@pflegenavi/frontend/api-nursing-home';
import { CommonProfileCover, NameAvatar } from '@pflegenavi/web-components';

interface ProfileCoverViewProps {
  name: string;
  isLoading?: boolean;
}

export const ProfileCoverView: FC<ProfileCoverViewProps> = ({
  name,
  isLoading = false,
}) => {
  if (isLoading) {
    return <Skeleton width="100%" height="100%" />;
  }

  return (
    <CommonProfileCover>
      <StyledNameAvatar fontSize={25} name={name} />
      <NameContainer>
        <Typography variant="h4">{name}</Typography>
      </NameContainer>
    </CommonProfileCover>
  );
};

export const ProfileCover: FC = () => {
  const { data: userProfile, isPending: isUserProfileLoading } =
    useFamilyMemberProfile({});

  const name = userProfile?.user
    ? `${userProfile?.user.firstName} ${userProfile?.user.lastName}`
    : '';

  return <ProfileCoverView name={name} isLoading={isUserProfileLoading} />;
};

const NameContainer = styled(Box)(({ theme }) =>
  theme.unstable_sx({
    ml: { md: 2 },
    mt: { xs: 1, md: 0 },
    color: 'text.primary',
    textAlign: { xs: 'center', md: 'left' },
  })
);

const StyledNameAvatar = styled(NameAvatar)(({ theme }) =>
  theme.unstable_sx({
    mx: 'auto',
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: 'common.white',
    width: { xs: 80, md: 100 },
    height: { xs: 80, md: 100 },
  })
);
